// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-2g4_FUTi","footerBox":"footerBox-2LqjESm1","footerItem":"footerItem-1qbyHL3U","footerLink":"footerLink-YuqGph4H"};